import React from 'react';
import RouteHeader from '../RouteHeader/routeHeader';
import ContentGrid from '../../../Helper/gridWrapper/gridWrapper';
import {bindActionCreators} from 'redux';
import load from 'load-script';
import {connect} from 'react-redux';
import {
    createEventAction,
    fetchEventAction,
    deleteEventAction,
    updateEventAction,
    fetchOwnEventAction
} from '../../../Actions/eventActions';
import { GetPotential } from '../../../Actions/dealActions';
import './events.css';
import EventAppView from './eventAppView';
import EventWebView from './eventsWebView';
import EventForm from './eventForm';
import Grid from '@material-ui/core/Grid';
import Alert from '../../../Helper/SimpleAlert/alert';
import ErrorComponent from '../../../Helper/ErrorComponent/errorComponent';
import './events.css';


class Events extends React.Component {
    constructor(props){
        super(props);
        this.state={
            data:{},
            editData:{},
            showSuccess:false,
            showError:false,
            Msg:'',
            showErrorComponent:false,
            pageNumber:1,
            deleteCount:0,
            ownEventsPageNumber:1,
            errorMesage:'',
            fetchEventObj: {
                UserId:props.user.results.AppUser.UserId,
                ToUserId:props.user.results.AppUser.UserId,
                lat:props.user.results.AppUser.Latitude,
                lng:props.user.results.AppUser.Longitude,
                PageNumber:1,
                PageSize:15,
                deleteCount:0,
                timeZoneOffsetInMinutes:new Date().getTimezoneOffset()*-1,
                strEventImageNameCommaSeparated:'0,0,0,0'
            },
            callEventForm:false
        }
    }

    componentDidMount() {
        const {user} = this.props;
        const {fetchEventObj} = this.state;
      load('https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyBr9MSaEjodT_Q9bnUqUcusJ8HWmQmJRC0', () => {
        this.setState({
          callEventForm: true
        })
      })
        this.props.fetchEventAction(fetchEventObj);
        this.props.fetchOwnEventAction(fetchEventObj);
        this.props.GetPotential(user.results.AppUser.UserId, user.results.BusinessUser.Address_Lat, user.results.BusinessUser.Address_Long, 'event');
    }

    handleEdit=(data)=>{
        this.setState({
            editData:data,
            showSuccess:false,
            showError:false,
            updated: true
        })
    };

    handleDelete=(data)=>{
        this.props.deleteEventAction({EventId:data.EventId,UserId:data.UserId}).then((data)=>{
            if(data.results.ResponseCode)
                this.setState({
                    editData:{},
                    data:{},
                    showSuccess:true,
                    showError:false,
                    Msg:'Event Deleted Successfully.',
                    deleteCount:this.state.deleteCount+1,
                });
            else
                this.setState({
                    editData:{},
                    showSuccess:false,
                    data:{},
                    showError:true,
                    Msg:'Error in Deletion.'
                });
        });
    };

    onSubmit=(data)=>{
        this.props.createEventAction(data).then((data)=>{
            if(data.results.ResponseCode)
                this.setState({
                    editData:{},
                    data:{},
                    showSuccess:true,
                    showError:false,
                    Msg:'Event Created Successfully.'
                });
            else
                this.setState({
                    editData:{},
                    data:{},
                    showError:true,
                    showSuccess:false,
                    Msg:'Error in Creation.'
                })
        });
    };

    eventAppScroll = (e, cnt) => {
        let scrollElement = e.target;
        if (scrollElement.scrollHeight - Math.floor(scrollElement.scrollTop) === scrollElement.clientHeight) {
            if(this.state.pageNumber * 15 < cnt)
            this.setState({
                pageNumber:this.state.pageNumber+1
            },()=>{
                this.props.fetchEventAction({...this.state.fetchEventObj,PageNumber:this.state.pageNumber,deleteCount:this.state.deleteCount});
            })
        }
    };

    ownEventScroll=(e)=>{
        let scrollElement = e.target;
        if (scrollElement.scrollHeight - scrollElement.scrollTop  === scrollElement.clientHeight) {
            if(this.state.ownEventsPageNumber * 15 < this.props.ownEvents.TotalCounts) {
                this.setState({
                    ownEventsPageNumber: this.state.ownEventsPageNumber + 1
                }, () => {
                    this.props.fetchOwnEventAction({
                        ...this.state.fetchEventObj,
                        PageNumber: this.state.ownEventsPageNumber,
                        deleteCount: this.state.deleteCount
                    });
                })
            }
        }
    };

    onUpdate=(data)=>{
        this.props.updateEventAction(data).then((data)=>{
            if(data.results.ResponseCode)
                this.setState({
                    editData:{},
                    data:{},
                    showSuccess:true,
                    showError:false,
                    Msg:'Event Updated Successfully.',
                    updated: false
                });
            else
                this.setState({
                    editData:{},
                    data:{},
                    showError:true,
                    showSuccess:false,
                    Msg:'Error in Updation.',
                    updated: false
                })
        });
    };
    onError=(flag,msg)=>{
        this.setState({
            showErrorComponent:flag,
            errorMesage:msg
        })
    };

    alertCallback=()=>{
        this.setState({
            showError:false,
            showSuccess:false
        })
    };

    render(){
        const { user } = this.props;
        return(
            <div>
                {
                    (this.state.showErrorComponent) &&
                    <ErrorComponent clickMethod={this.onError} msg={this.state.errorMesage}/>
                }
                <div className='container-div'>
                  {this.state.callEventForm && <ContentGrid
                    header={
                        user.results.BusinessUser.IsFirstVisit && JSON.parse(user.results.BusinessUser.IsFirstVisit)['My Local Events']?
                        <RouteHeader title={'My Local Events'}
                                     text={`is a place where you can publish events that will be seen by all users
                                     within 15 mile radius.`}
                        />:<span/>
                    }
                    content={
                        <Grid container spacing={24}>
                            <Grid item sm={12} xs={12}>
                                <EventForm onCreateEvent={this.onSubmit}
                                           onUpdateEvent={this.onUpdate}
                                           user={this.props.user}
                                           upDated={this.state.updated}
                                           editData={this.state.editData}
                                           showError={this.onError}
                                           potentialCount={this.props.potentialCount.results}
                                />
                            </Grid>
                            <Grid item sm={12} xs={12}>
                                <Alert onClose={this.alertCallback} showSuccess={this.state.showSuccess}
                                       showError={this.state.showError} Msg={this.state.Msg}/>
                                {
                                    this.props.ownEvents.EventDetailData.length > 0 &&
                                    <EventWebView ownEvents={this.props.ownEvents}
                                                  user={this.props.user}
                                                  onEdit={this.handleEdit}
                                                  onDelete={this.handleDelete}
                                                  eventAppScroll={this.ownEventScroll}
                                    />
                                }
                            </Grid>
                        </Grid>
                    }
                    appView={
                        <EventAppView eventAppScroll={this.eventAppScroll}
                                      user={this.props.user}/>
                    }
                />}
                </div>
            </div>
        )
    }
}
const mapStateToProps=(state)=> {
    return {
        user:state.loginResponse,
        ownEvents:state.ownEvents,
        potentialCount:state.potentialCount,
        loading:state.loading
    }
};
const matchDispatchToProps=(dispatch)=> {
    return bindActionCreators({
        createEventAction,
        fetchEventAction,
        deleteEventAction,
        updateEventAction,
        fetchOwnEventAction,
        GetPotential
    },dispatch)
};
export default connect(mapStateToProps,matchDispatchToProps)(Events);